import { render } from "./Background.vue?vue&type=template&id=2da234d2&scoped=true&ts=true"
import script from "./Background.vue?vue&type=script&lang=ts"
export * from "./Background.vue?vue&type=script&lang=ts"

import "./Background.scss?vue&type=style&index=0&id=2da234d2&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da234d2"]])

export default __exports__